module.exports = __webpack_public_path__ + "img/Alaaelden.fb9cbe8.png";